import "./winLg.css"

const WinLg = () => {
    return (
        <div className="winLg">
            am tje large guy
        </div>
    )
}

export default WinLg
